import TableHead from '@mui/material/TableHead';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import { Order } from '../../../types';
import { Box, Checkbox, TableCell, TableRow } from '@mui/material';

export interface DataTableHeadCellData {
  id: string,
  disablePadding?: boolean,
  label: string,
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify',
  cellAlign?: string,
  sortable?: boolean,
  searchable?: boolean,
  width?: string,
}

interface DataTableProps {
  numSelected: number;
  onRequestSort?: (event: React.MouseEvent<unknown>, property: any) => void;
  onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order?: Order;
  orderBy?: string;
  rowCount: number;
  headCells: DataTableHeadCellData[];
  hideIdCheckbox?: boolean;
}

export const DataTableHeader = (props: DataTableProps) => {
  const { 
    onSelectAllClick, 
    order, 
    orderBy, 
    numSelected, 
    rowCount, 
    headCells, 
    onRequestSort,
    hideIdCheckbox,
  } = props;
  const createSortHandler =
    (property: any) => (event: React.MouseEvent<unknown>) => {
      onRequestSort && onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {
          !hideIdCheckbox && (
            <TableCell padding="checkbox">
              <Checkbox
                color="primary"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{
                  'aria-label': 'select all desserts',
                }}
              />
            </TableCell>
          )
        }
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            align={headCell.align ?? 'center'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            width={headCell.width}
            sx={{ paddingLeft: (index == 0 && hideIdCheckbox) ? "20px" : undefined  }} 
          >
            {
              headCell.sortable ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {headCell.sortable ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              ) : (
                <span>{headCell.label}</span>
              )
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}